import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromPartCostsNotSavedChanges from './state/part-costs-not-saved-changes.reducer';
import { PartCostsNotSavedChangesFacade } from './state/part-costs-not-saved-changes.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromPartCostsNotSavedChanges.PART_COSTS_NOT_SAVED_CHANGES_FEATURE_KEY,
      fromPartCostsNotSavedChanges.partCostsNotSavedChangesReducer
    ),
  ],
  providers: [PartCostsNotSavedChangesFacade],
})
export class PartCostsNotSavedChangesModule {}
